// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1fXer","footer":"ModalCreateQualiphyProcedure_footer__1P0WW","additionData":"ModalCreateQualiphyProcedure_additionData__1HRSb"};